(function(doc, win) {
    let docEl = doc.documentElement,
        resizeEvt = 'onorientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function() {
            const clientWidth = docEl.clientWidth
            if (!clientWidth) return
            let orientation = window.orientation
            switch (orientation) {
                case 90:
                case -90:
                    orientation = 'landscape'
                    break
                default:
                    orientation = 'portrait'
            }
            docEl.setAttribute('class', orientation)
            docEl.style.fontSize = `${50 * (clientWidth / 375)}px`
        }
    recalc1 = function() {
        setTimeout(() => {
            const clientWidth = docEl.clientWidth
            if (!clientWidth) return
            let orientation = window.orientation
            switch (orientation) {
                case 90:
                case -90:
                    orientation = 'landscape'
                    break
                default:
                    orientation = 'portrait'
            }
            docEl.setAttribute('class', orientation)
            docEl.style.fontSize = `${50 * (clientWidth / 375)}px`
        }, 300)
    }
    if (!doc.addEventListener) return
    win.addEventListener(resizeEvt, recalc1, false)
    doc.addEventListener('DOMContentLoaded', recalc, false)
    recalc()
}(document, window))